module.exports = __webpack_public_path__ + "static/lunchtype24-light-expanded-webfont-b4f7811930b920d74e6bf43b6a76db5b.woff";